import { RedirectionService } from 'services/RedirectionService';
import { randomIntRange } from 'utils/math';

import CONFIG from '../../../app.config';
import { CONCIERGE_PATH } from '../../containers/App/Routes';

import { DEFAULT_CONFIG } from './funnelConfigs';
import { CONCIERGE_KEY } from './utils';

export const createOrderOfSteps = ({
  requestedFirstStep,
  setQueue,
  setNextStep,
  storage,
}) => {
  // Default order for steps
  const baseOrder = DEFAULT_CONFIG.order;

  // Remove already answered steps
  let order = removeAnsweredStepsFromQueue(storage.progress, baseOrder);
  order = rearrangeQueue(requestedFirstStep, order);

  // Update queue with final order of steps
  setQueue(order);
  const nextStep = order.length > 0 ? order[0] : null;

  if (!nextStep) {
    // If we can't figure out next step, redirect to main page
    new RedirectionService().redirect({
      url: CONFIG.SEARCH_APP_URL,
      reason: 'no-next-step',
    });
  }

  // Update URL so user is sent on their merry way
  setNextStep(nextStep);

  // Just to be safe, also return the order for consumption
  return order;
};

const removeAnsweredStepsFromQueue = (savedSteps, queue) => {
  if (!savedSteps || savedSteps.length === 0) return queue;

  return queue.filter(step => {
    const found = savedSteps[step.name.toLowerCase()];

    return found && !found.isComplete || !found;
  });
};

const rearrangeQueue = (url, queue) => {
  // safe checks
  if (!url || url.indexOf(CONCIERGE_PATH) === -1 || !url.split('/')[2])
    return queue;

  // Transform URL into requested step
  const requestedStepUrl = url.split('/')[2].replace(/\//g, '');

  const requestedStep = Object.values(CONFIG).find(
    step => step.path === requestedStepUrl,
  );

  // Return unchanged queue if url doesn't translate to a step
  if (!requestedStep) return queue;

  // Find in queue
  const index = queue.findIndex(
    step => step.name.toLowerCase() === requestedStep.name,
  );

  // if already first in queue, or non-existent, return queue as is
  if (index <= 0) {
    return queue;
  }

  // proceed to reorder the queue
  const component = queue[index];
  const reorderedQueue = [...queue];

  reorderedQueue.splice(index, 1);
  reorderedQueue.unshift(component);

  return reorderedQueue;
};

export const selectAndSavePartner = (partners, storage) => {
  const chosenPartner = randomIntRange(0, partners.length - 1);
  storage.save(CONCIERGE_KEY.PARTNER, partners[chosenPartner], true);
};
